module.exports = __webpack_public_path__ + "assets/modeds_light.d30d73dd.svg";